export function request(id, query, aggregations) {
    return {
        type: 'BETS_QUERY_REQUEST',
        query,
        aggregations,
        id
    };
}

export function error(id, errors) {
    return {
        type: 'BETS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, data, aggregations) {
    return {
        type: 'BETS_QUERY_FINISH',
        aggregations,
        data,
        id
    };
}

export function clear(id) {
    return {
        type: 'BETS_QUERY_CLEAR',
        id
    };
}
